import { useQuery } from "@tanstack/react-query";
import {
  fetchNextBookings,
  UpcomingBookingsResponse
} from "PFCore/services/marketplace/fetch_marketplace_next_bookings";
import { Id } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import { activitiesKeys } from "../query_keys";

export const useUpcomingBookings = (profileId: Id, options: QueryOptions<UpcomingBookingsResponse> = {}) =>
  useQuery<UpcomingBookingsResponse>(activitiesKeys.all(profileId), () => fetchNextBookings(), options);
